// src/pages/DebtStudio/components/TopTabMenu.jsx
import React from "react";

export default function TopTabMenu({
  tabs,
  activeTab,
  onChange,
  ariaLabel,
  actions = null,
}) {
  return (
    <div
      className="flex bg-app rounded-t-2xl overflow-hidden"
      role={ariaLabel ? "tablist" : undefined}
      aria-label={ariaLabel}
    >
      {tabs.map((tab, i) => {
        const key = tab?.key ?? String(i);
        const label = tab?.label ?? tab?.key ?? String(tab ?? "");
        const isDisabled = !!tab?.disabled;

        const isActive = activeTab === key;
        const isFirst = i === 0;
        const isLast = i === tabs.length - 1;

        return (
          <button
            key={key}
            type="button"
            onClick={() => {
              if (isDisabled) return;
              onChange(key);
            }}
            disabled={isDisabled}
            aria-disabled={isDisabled || undefined}
            role={ariaLabel ? "tab" : undefined}
            aria-selected={ariaLabel ? isActive : undefined}
            aria-controls={ariaLabel ? `tabpanel-${key}` : undefined}
            id={ariaLabel ? `tab-${key}` : undefined}
            title={isDisabled ? tab?.disabledTitle || "Read-only" : undefined}
            className={`px-6 py-3 font-medium transition-colors border border-border
              ${
                isDisabled
                  ? "bg-muted text-muted opacity-60 cursor-not-allowed"
                  : isActive
                  ? "bg-app text-brand relative z-10"
                  : "bg-muted text-muted hover:text-app hover:bg-muted/70"
              }
              ${isFirst ? "rounded-tl-2xl" : ""}
              ${isLast ? "rounded-tr-2xl" : ""}
              ${!isLast ? "-mr-px" : ""}
            `}
          >
            {label}
          </button>
        );
      })}
      {actions ? (
        <div className="ml-auto flex items-center px-4 border-b border-border">
          {actions}
        </div>
      ) : null}
    </div>
  );
}
